import type { UseQueryResult } from '@tanstack/react-query'
import { Text } from '@wartek-id/text'

import { EmptyState } from 'components/EmptyState'
import GenericList from 'components/GenericList'
import ModulePlaceholder from 'components/Module/ModulePlaceholder'

import SJTCard from './SJTCard'

import type { CommonListResponse } from 'typings/api'
import type { TAPIGetSJTPPGDaljabResponse } from 'typings/ppg-daljab'

const SJTContent = ({
  data,
  isLocked = true,
}: {
  data: UseQueryResult<CommonListResponse<TAPIGetSJTPPGDaljabResponse>>
  isLocked: boolean
}) => {
  const randomizeItems = data?.data?.data?.sort(() => Math.random() - 0.5) || []

  return (
    <>
      <div className="px-3 relative">
        <GenericList
          className="relative"
          data={randomizeItems}
          dataState={data?.status}
          beforeList={
            <div className="mb-2">
              <Text variant="heading-md">Post test</Text>
              <Text variant="body" color="subdued">
                Hasil post test pertama akan dipakai sebagai acuan pemahaman
                Anda.
              </Text>
            </div>
          }
          loadingComponent={
            <div className="pt-4">
              <ModulePlaceholder amount={3} />
            </div>
          }
          emptyComponent={
            <EmptyState
              fullscreen={false}
              title="SJT belum tersedia"
              description="Belum ada SJT yang dapat dipelajari saat ini, silahkan coba lagi nanti."
            />
          }
          renderItem={(item) => (
            <div className="mb-4">
              <SJTCard item={item} isLocked={isLocked} />
            </div>
          )}
          listKey={({ id }) => id}
        />
      </div>
    </>
  )
}

export default SJTContent
